<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-lg-12">
          <validated-form-input name="amount" label="Limiit:" placeholder="Limiidi väärtus"
                                v-model="limit.amount"
                                validate="numeric|max_value:9999999" :validator="$validator"/>

          <validated-form-input :datepicker="true" name="limitDate" label="Seadmise kuupäev:"
                                placeholder="Seadmise kuupäev"
                                v-model="limit.date"
                                validate="required" :validator="$validator"/>

          <validated-form-textarea name="details" label="Lisainfo:" placeholder="Lisainfo"
                                   v-model="limit.details" :rows="2" :maxRows="8"
                                   :validator="$validator"/>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <submit-button class="float-right" variant="primary">Salvesta</submit-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import ValidatedFormInput from '@/components/ValidatedFormInput'
import ValidatedFormTextarea from '@/components/ValidatedFormTextarea'
import gateway from '@/services/gateway'

export default {
  components: {ValidatedFormInput, ValidatedFormTextarea},
  props: ['client'],
  data() {
    return {
      limit: {
        date: null,
        amount: null,
        details: ''
      },
    }
  },
  created() {
    this.limit.amount = this.client.creditLimitTotal
    this.limit.date = this.client.creditLimitDate
    this.limit.details = this.client.creditLimitDetails
  },
  methods: {
    submit() {
      this.$validator.validateAll().then((valid) => {
        if (!valid) return
        this.limit.amount = this.limit.amount || 0
        gateway.post('/clients/' + this.client.id + '/credit-limit', this.limit)
          .then(() => this.$notifications.info('Krediidilimiit salvestatud'))
          .then(() => this.$emit('done'))
      })
    }
  }
}
</script>
